import { RESTproxy } from '../RESTproxy';
import { config } from '../../../config';
import { fetchWithAuth } from '../fetchWithAuth';

export class ChallengesProxy extends RESTproxy {
    constructor() {
        super('challenge');
    }

    async publish(id) {
        const res = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/challenge/${id}/publish`, {
            method: 'POST',
        });
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
    }

    async remove(id) {
        const res = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/challenge/${id}`, {
            method: 'DELETE',
        });
        if (!res.ok) throw new Error(res.statusText);
    }

    async getResults(id) {
        const res = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/challenge/${id}/results`);
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
    }

    async listSubmissions(id) {
        const res = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/challenge/${id}/submissions`);
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
    }

    async listNonSubmitters(id) {
        const res = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/challenge/${id}/non-submitters`);
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
    }

    async getTemplateItems(templateId) {
        const res = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/challenge/template/${templateId}/items`);
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
    }

    async uploadImage(file) {
        const formData = new FormData();
        formData.append('file', file);
        const res = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/challenge/image`, {
            method: 'POST',
            body: formData,
        });
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
    }

    async suggestConcept({ roomType, seed } = {}) {
        const res = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/challenge/suggest-concept`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ roomType, seed }),
        });
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
    }

    async suggestRestrictionMessages(restrictions) {
        const res = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/challenge/suggest-restriction-messages`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ restrictions }),
        });
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
    }

    async suggestStartDate() {
        const res = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/challenge/suggest-start-date`);
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
    }

    async suggestImage(prompt) {
        const startRes = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/challenge/suggest-image`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ prompt }),
        });
        if (!startRes.ok) throw new Error(startRes.statusText);
        const { jobId } = await startRes.json();
        if (!jobId) throw new Error('No jobId returned');

        const POLL_INTERVAL_MS = 2000;
        const TIMEOUT_MS = 3 * 60 * 1000;
        const deadline = Date.now() + TIMEOUT_MS;
        while (Date.now() < deadline) {
            await new Promise(r => setTimeout(r, POLL_INTERVAL_MS));
            const pollRes = await fetchWithAuth(
                `${config().catalogueServiceBaseUrl}/challenge/suggest-image/${jobId}`,
            );
            if (!pollRes.ok) throw new Error(pollRes.statusText);
            const job = await pollRes.json();
            if (job.status === 'done') return { url: job.url };
            if (job.status === 'error') throw new Error(job.error || 'Image generation failed');
        }
        throw new Error('Image generation timed out');
    }
}
